<template>
<div class="demand-modal">
  <div class="text-center" v-if="!show_demand_form">
    <p>Não encontrou o que estava buscando?</p>
    <h4>
      <button @click="showDemandForm" type="button" class="btn btn-primary">Envie-nos a sua demanda!</button>
    </h4>
  </div>
  <b-modal v-model="show_demand_form" title="Envie-nos a sua demanda!" hide-footer hide-header>
    <div v-if="!demand_code">
      <b-form @submit.prevent="createDemand" v-if="!isLoading && show_demand_form">
        <h5>Complete os dados abaixo para enviar sua demanda</h5>
        <br>
        <div class="row">
          <div class="col-sm-12">
            <b-form-group label="Nome *">
              <b-form-input v-model="form.name" v-validate="'required'" name="name" />
              <field-error :msg="veeErrors" field="name" />
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group label="Email *">
              <b-form-input v-model="form.email" v-validate="'email|required'" name="email" />
              <field-error :msg="veeErrors" field="email" />
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group label="Telefone / Whatsapp *">
              <b-form-input v-model="form.phone" v-validate="'required'" name="phone" placeholder="(99) 99999-9999" v-mask="['(##) ####-####', '(##) #####-####']" />
              <field-error :msg="veeErrors" field="phone" />
            </b-form-group>
          </div>
          <div class="col-sm-12">
            <b-form-group label="Qual tipo de produto você busca?">
              <select v-model="form.category" class="form-control">
                <option value="">{{form.category ? "Todas as categorias" : "Selecione a categoria"}}</option>
                <option :value="categoria" v-for="(categoria, index) in categorias_de_produtos" :key="index">{{categoria}}</option>
              </select>
            </b-form-group>
          </div>
          <div class="col-sm-12">
            <b-form-group label="Descrição da demanda *">
              <b-form-textarea v-model="form.description" placeholder="Descreva aqui o produto que você quer comprar" v-validate="'required'" name="description" />
              <field-error :msg="veeErrors" field="description" />
            </b-form-group>
          </div>
        </div>
        <form-submit :errors="error" :sending="isSending" label="Enviar demanda" />
      </b-form>
    </div>
    <div v-else class="text-center">
      <h4>Sua demanda foi cadastrada com sucesso!</h4>
      <p>Nossa equipe se mobilizará para atender sua demanda e <br> em breve entrará em contato com você.</p>
      <p>O código da sua demanda é: #{{demand_code}}</p>
      <button @click="show_demand_form = false" type="button" class="btn btn-primary btn-lg">Voltar para a loja</button>
    </div>
  </b-modal>
</div>
</template>
<script>
import axios from 'axios'
import FormSubmit from '@/components/FormSubmit'
import FieldError from '@/components/FieldError'
import categorias_de_produtos from '@/data/categorias-de-produtos.json'

export default {
  components: {
    FieldError,
    FormSubmit
  },
  data() {
    return {
      categorias_de_produtos,
      demand_code: null,
      show_demand_form: false,
      form: {
        name: "",
        email: "",
        phone: "",
        category: "",
        description: "",
      }
    }
  },
  methods: {
    showDemandForm() {
      const currentUser = this.$store.state.currentUser
      if (currentUser) {
        this.form.name = currentUser.name
        this.form.email = currentUser.email
        this.form.phone = currentUser.phone
      }
      this.show_demand_form = true
    },
    createDemand() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          axios({
            method: 'POST',
            url: 'shop/demand',
            data: this.form
          }).then(resp => {
            var demand = resp.data
            if (demand && demand._id) {
              this.demand_code = demand.code
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    }
  }
};
</script>
